import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslate } from 'react-localize-redux'
import Auth from '../../auth'
import history from '../../history'

import {
  setActiveLanguage,
  getActiveLanguage
} from 'react-localize-redux'

import {
  LOGIN_SUCCESS,
  LOGIN_FAIL
} from '../../common/constants'

import {
  login,
  setProfile,
  setAuthToken,
  setAuthError,
  setAuthErrorMessage,
  userGet,
  resetAllReducers,
  getSoftwareUpdate,
  resetMfaState,
  requestOtpVerification,
  sendOtp,
  verifyOtp
} from '../../redux/actions'

/* Components */
import LoginForm from '../../components/login'
import {getAppSetting} from "../../redux/actions/appSettingActions";
import Notify from "../../redux/actions/notifyActions";

const auth = new Auth()

class LoginPage extends Component {

  componentWillMount() {
    this.props.reset()
    this.props.resetMfaState()
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.mfaVerified && !this.props.mfaVerified) {
      const { completeSignIn, tempData } = this.props;

      completeSignIn(tempData);
    }
  }

  render() {
    const {
      classes,
      valid,
      translate,
      activeLanguage,
      languages,
      setLanguage,
      login,
      mfaVerificationRequested,
      mfaUsername,
      sendOtp,
      verifyOtp,
      mfaError
    } = this.props

    return (
      <LoginForm
        setLanguage={setLanguage}
        activeLanguage={activeLanguage}
        languages={languages}
        login={login}
        valid={valid}
        translate={translate}
        mfaVerificationRequested={mfaVerificationRequested}
        mfaUsername={mfaUsername}
        sendOtp={sendOtp}
        verifyOtp={verifyOtp}
        mfaError={mfaError}
      />
  )
  }
}

function completeSignInFunc(dispatch, data) {
  const {
    access_token,
    refresh_token,
    id,
    name,
    roles,
    rolenames,
    customerid,
    customer,
    mfaEnabled
  } = data

  let expires = (new Date(data['.expires'])).getTime()
  dispatch(setAuthToken({
    access_token,
    refresh_token,
    expires
  }))

  auth.handleAuthentication({
    access_token,
    refresh_token,
    expires
  })

  dispatch(setProfile({
    id,
    name,
    roles,
    rolenames,
    customerid,
    customer
  }));

  dispatch(getSoftwareUpdate());
  dispatch(getAppSetting());
  dispatch(userGet(data.id, true))

  if (mfaEnabled.toLowerCase() === 'false') {
    setTimeout(() => {
      dispatch(Notify.success('mfa_suggestion_toast'));
    }, 10000);
  }

  if (data.roles === 'clientadmin'
    || data.roles === 'clientmanager'
    || data.roles === 'clientuser')
    history.replace('/jobs')
  else if (data.roles === 'idealadmin'
    || data.roles === 'idealsupport')
    history.replace('/organisations')
  else
    history.replace('/jobs')
}

const mapStateToProps = (state) => ({
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  languages: state.localeReducer.languages,
  translate: getTranslate(state.localeReducer),
  mfaVerificationRequested: state.mfaReducer.mfaVerificationRequested,
  mfaUsername: state.mfaReducer.mfaUsername,
  mfaVerified: state.mfaReducer.mfaVerified,
  mfaError: state.mfaReducer.mfaError,
  tempData: state.mfaReducer.tempData,
  valid: true,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  login: (form) => {
    dispatch(resetAllReducers()).then(() => {
      dispatch(login(form)).then((response) => {
        switch (response.type) {
          case LOGIN_SUCCESS:
            if (response.payload.data.success) {
              const {
                mfaDeviceTrusted
              } = response.payload.data

              // Check if the device is trusted, otherwise request OTP verification
              if (mfaDeviceTrusted.toLowerCase() == 'false') {

                  dispatch(requestOtpVerification({
                    emailAddress: form.username,
                    contactNumber: null,
                    tempData: response.payload.data
                  }))
                return;

              }

              completeSignInFunc(dispatch, response.payload.data)
            } else {
              // dispatch(setAuthErrorMessage(translate('login_invalid')))
              dispatch(setAuthError(true))
            }
            break
          case LOGIN_FAIL:
            // dispatch(setAuthErrorMessage(translate('login_failed')))
            dispatch(setAuthError(true))
            break
        }
      })
    })
  },
  completeSignIn: (data) => {
    completeSignInFunc(dispatch, data)
  },
  setLanguage: (language) => {
    localStorage.setItem("language", language)
    dispatch(setActiveLanguage(language))
  },
  reset: () => {
    dispatch(setAuthError(false))
  },
  resetMfaState: () => {
    dispatch(resetMfaState())
  },
  sendOtp: (request) => {
    dispatch(sendOtp({
      username: request.username,
      method: request.method,
      emailAddress: request.emailAddress,
      contactNumber: request.contactNumber
    }))
  },
  verifyOtp: (form) => {
    dispatch(verifyOtp({
      username: form.username,
      otp: form.otp,
      method: form.method,
    }));
  }
})

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  stateProps.valid = !stateProps.authReducer.error
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LoginPage)



// WEBPACK FOOTER //
// ./src/pages/login/index.js